export default __webpack_public_path__ + "static/media/japangot-screenshot-05.8925dbd0.png";